import { render, staticRenderFns } from "./PreisMonitor.vue?vue&type=template&id=b8100772&scoped=true"
import script from "./PreisMonitor.vue?vue&type=script&lang=js"
export * from "./PreisMonitor.vue?vue&type=script&lang=js"
import style0 from "./PreisMonitor.vue?vue&type=style&index=0&id=b8100772&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8100772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8100772')) {
      api.createRecord('b8100772', component.options)
    } else {
      api.reload('b8100772', component.options)
    }
    module.hot.accept("./PreisMonitor.vue?vue&type=template&id=b8100772&scoped=true", function () {
      api.rerender('b8100772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PreisMonitor.vue"
export default component.exports